import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../theme/theme';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// Components
import { LoginScreenComponent } from './login.component';
// Services
import { AuthenticationService, AuthGuard, SignUpGuard, PendingGuard, ErrorParseService, LoginGuard } from '../../commons';
import { reducers } from './state/login.selectors';
import { LoginRouter } from './login.router';
import { AppCommonModule } from 'src/app/common.module';
import { FlexLayoutModule } from '@angular/flex-layout';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        AppCommonModule
    ],
    declarations: [],
    exports: []
})
export class LoginScreenModule {
    static forRoot(): ModuleWithProviders<LoginScreenModule> {
        return {
            ngModule: AuthenticationModule,
            providers: [AuthenticationService, AuthGuard, SignUpGuard, PendingGuard, ErrorParseService],
        };
    }
}

@NgModule({
    imports: [
        LoginScreenModule,
        LoginRouter,
        StoreModule.forFeature('authentication', reducers),
    ],
    providers: [LoginGuard]
})
export class AuthenticationModule { }